import { createAction } from '@reduxjs/toolkit';
import type { ProfileSort } from '@shared/schemas';

import type { FilterGroup } from '@/types/filters';

import type { DeactivateScope } from '../infrastructure/profiles.gateway';

/**
 * "Signal" actions: intents the UI dispatches for the saga to act on. Kept out of
 * the slice's reducers: they trigger the paginated fetch / bulk deactivate (side
 * effects), not the state transitions (the saga owns the resulting `load*` /
 * `deactivate*` / cursor transitions).
 */

/** Refetch the current page (mount and after out-of-band mutations like add-tags). */
export const profilesRequested = createAction('profiles/profilesRequested');

/** The debounced, pruned server filters changed (resets to the first page). */
export const filtersChanged = createAction<FilterGroup | null>('profiles/filtersChanged');

/**
 * A sort arrow was clicked (#714): the server orders the whole list, and the
 * table goes back to its first page. Null = back to the default name order.
 */
export const sortChanged = createAction<ProfileSort | null>('profiles/sortChanged');

/** Navigate to a 0-indexed page. */
export const pageChanged = createAction<number>('profiles/pageChanged');

/** Change the page size (resets to the first page). */
export const pageSizeChanged = createAction<number>('profiles/pageSizeChanged');

/** Bulk-deactivate the given profile ids within `scope`. */
export const deactivateRequested = createAction<{ ids: string[]; scope: DeactivateScope }>(
  'profiles/deactivateRequested',
);
